import React, { useState } from 'react';
import ajaxPeriod from '../../util/remote/ajaxPeriod';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import ActivityLoader from '../Common/ActivityLoader';

const NewPeriod = () => {
    const [newPeriod, setNewPeriod] = useState({ startDate: '', endDate: '' });
    const [loading, setLoading] = useState(false);
    const { setNotify } = useTheme();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewPeriod({ ...newPeriod, [name]: value });
    };

    const startPeriod = async (e) => {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        const server_response = await ajaxPeriod.startNewPeriod(newPeriod.startDate, newPeriod.endDate);
        setLoading(false);
        if (server_response.status === "OK") {
            setNotify(<Notification type='success' message={server_response.message} />);
            setTimeout(() => { window.location.reload(); }, 5000);
        } else {
            setNotify(<Notification type='danger' message={server_response.message} />);
        }
    };

    return (
        <div className="w-100">
            <style>{`
                .period-card { background: #fff; border-radius: 16px; border: none; box-shadow: 0 1px 3px rgba(0,0,0,0.02); }
                .period-header { color: #1E293B; font-weight: 700; font-size: 0.95rem; letter-spacing: -0.01em; border: none; background: none; }
                
                .input-group-custom { display: flex; align-items: center; background: #F8FAFC; border-radius: 8px; border: 1px solid #E2E8F0; }
                .input-label { 
                    padding: 8px 16px; color: #64748B; font-weight: 700; 
                    font-size: 10px; text-transform: uppercase; letter-spacing: 0.05em;
                    border-right: 1px solid #E2E8F0; min-width: 100px;
                }
                .input-field { 
                    background: transparent; border: none; padding: 8px 12px; 
                    font-size: 14px; color: #1E293B; font-weight: 600; outline: none; width: 100%;
                }
                .btn-indigo { 
                    background: #4F46E5; color: #fff; border: none; padding: 10px 24px; 
                    border-radius: 8px; font-weight: 700; transition: all 0.2s; 
                }
                .btn-indigo:hover { background: #4338CA; transform: translateY(-1px); }
                .btn-indigo:disabled { background: #94A3B8; cursor: not-allowed; }
            `}</style>

            <div className="card period-card">
                <div className="card-body p-4">
                   
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h6 className="period-header m-0">Create New Financial Period</h6>
                    </div>

                    <form className="row align-items-end" onSubmit={startPeriod}>

                        <div
                            className="col-md-8 d-flex align-items-center justify-content-center"
                            style={{
                            borderRadius: 8,
                            border: "1px solid #E2E8F0",
                            backgroundColor: "#F8FAFC",
                            height: 38,
                            }}
                        >
                        <input
                            type="date"
                            className="form-control border-0 bg-transparent shadow-none"
                            value={newPeriod.startDate ?? ""}
                            onChange={(e) => handleInputChange({ target: { name: 'startDate', value: e.target.value }})}
                            style={{ height: 36, fontSize: 12, width: 150, padding: "0 6px" }}
                        />
                        <span className="text-muted small mx-1">to</span>
                        <input
                            type="date"
                            className="form-control border-0 bg-transparent shadow-none"
                            value={newPeriod.endDate ?? ""}
                            onChange={(e) => handleInputChange({ target: { name: 'endDate', value: e.target.value }})}
                            style={{ height: 36, fontSize: 12, width: 150, padding: "0 6px" }}
                        />
                    </div>


                        <div className="col-md-4">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={!newPeriod.startDate || !newPeriod.endDate || loading}
                                onClick={startPeriod}
                            >
                                {!loading ? (
                                    <>
                                        <i className="fas fa-plus-circle mr-2" />
                                        Create Period
                                    </>
                                ) : (
                                    <ActivityLoader inline={true} colors={['#FFFFFF', '#DEDEDE']} />
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NewPeriod;